import React from 'react';

import * as SearchT3Actions from './actions';
import * as SearchT3Constants from './constants';
import * as D from './deps';
import SearchReducer from './reducer';
import SearchT3Watchers from './sagas/watchers';
import * as SearchT3Selectors from './selectors';
import * as SearchT3Utils from './utils';

export default D.createDomainModule({
  name: 'searchT3',
  actions: SearchT3Actions,
  reducer: SearchReducer,
  constants: SearchT3Constants,
  selectors: SearchT3Selectors,
  utils: SearchT3Utils,
  components: {
    SearchModal: (props: $TSFixMe) => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_search-modal" */ './containers/SearchModal/SearchModal',
            )
          }
        />
      );
    },
    BabySearchInput: (props: $TSFixMe) => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_baby-search-input" */ './components/BabySearchInput/BabySearchInput.tsx',
            )
          }
        />
      );
    },
    SearchPlaceholder: (props: $TSFixMe) => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_search-placeholder" */ './components/SearchPlaceholder/SearchPlaceholder.tsx',
            )
          }
        />
      );
    },
  },
  onStart() {
    this.registeredHandlers = D.registerHandlers(SearchT3Watchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
